(function (window) {
	"use strict";
	function defineArrayHelper() {
		var arrayHelper = {};
		arrayHelper.sortByPropertyNumeric = function(property){
			var sortOrder = 1;
			//reverse order if property name contains dash at the beginning
			if(property[0] === "-") {
				sortOrder = -1;
				property = property.substr(1);
			}
			return function (a,b) {
				if(a[property] < b[property]){
					return - 1 * sortOrder;
				}
				if(a[property] > b[property]){
					return 1 * sortOrder;
				}
				//var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
				//return result * sortOrder;
				return 0 * sortOrder;
			};
		};
		arrayHelper.sortByPropertyString = function(property){
			var sortOrder = 1;
			//reverse order if property name contains dash at the beginning
			if(property[0] === "-") { 
				sortOrder = -1;
				property = property.substr(1);
			}
			return function (a,b) {
				var stringValue1 = a[property].toLowerCase();
				var stringValue2 = b[property].toLowerCase();
				if(stringValue1 < stringValue2){
					return - 1 * sortOrder;
				}
				if(stringValue1 > stringValue2){
					return 1 * sortOrder;
				}
				//var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
				//return result * sortOrder;
				return 0 * sortOrder;
			};
		};
		arrayHelper.sortByPropertyDate = function(property){
			var sortOrder = 1;
			//reverse order if property name contains dash at the beginning
			if(property[0] === "-") {
				sortOrder = -1;
				property = property.substr(1);
			}
			return function (a,b) {
				var date1 = new Date(a[property]);
				var date2 = new Date(b[property]);
				if(date1 < date2){
					return - 1 * sortOrder;
				}
				if(date1 > date2){
					return 1 * sortOrder;
				}
				//var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
				//return result * sortOrder;
				return 0 * sortOrder;
			};
		};
		return arrayHelper;
	}
	//define globally if it doesn't already exist
	if (typeof (arrayHelper) === "undefined") {
		window.arrayHelper = defineArrayHelper();
	} else {
		console.log("arrayHelper already defined.");
	}
})(window);